import { ReactNode } from 'react';
import {
    MoreCircleIcon,
    TickSquareIcon,
    CloseSquareIcon,
    FlashStatusIcon
} from './icons';

const StatusIndicator = ({ status }: { status: string }) => {
    const views: {
        [key: string]: {
            background: string;
            icon: ReactNode;
        };
    } = {
        Processing: {
            background: 'bg-lightYellow',
            icon: <MoreCircleIcon />
        },
        Completed: {
            background: 'bg-green',
            icon: <TickSquareIcon />
        },
        Canceled: {
            background: 'bg-orange',
            icon: <CloseSquareIcon />
        },
        Initiated: {
            background: 'bg-paleSky',
            icon: <FlashStatusIcon />
        },
        Disabled: {
            background: 'bg-paleSky',
            icon: <FlashStatusIcon />
        },
        Active: {
            background: 'bg-green',
            icon: <TickSquareIcon />
        },
        Failed: {
            background: 'bg-orange',
            icon: <CloseSquareIcon />
        },
        Pending: {
            background: 'bg-lightYellow',
            icon: <MoreCircleIcon />
        }
    };

    return (
        <div
            className={`w-[44px] h-[44px] rounded-[8px] flex justify-center items-center ${views[status]?.background}`}
        >
            {views[status]?.icon}
        </div>
    );
};

export default StatusIndicator;
